import { FC } from 'react';
import { useStepperConsumer } from '@app/components/Stepper';
import { BreakpointsEnum } from '@app/types';
import { COLORS } from '@app/constants';
import { useClientSize } from '@app/hooks/';
import { useRouter } from 'next/router';
import { ROUTES } from '@app/routers';
import styled from 'styled-components';
import {
  getBackgroundImageByRole,
  getMobileBackgroundImageByRole,
} from '../ChooseWay/helpers';
import Container from '@app/components/Container';
import clientAskonaBackground from '@app/assets/images/client-askona-auth-background.svg';
import clientAskonaBackgroundMobile from '@app/assets/images/client-askona-auth-background-mobile.svg';
import { UserResponseDtoRoleEnum } from '@app/api';

const SignUp: FC = () => {
  const router = useRouter();
  const { activeComponent } = useStepperConsumer();

  const { getIsBreakpoint } = useClientSize();
  const isMobile = getIsBreakpoint('s');

  const isAskona = router.pathname === ROUTES['/sign-up/client-askona'];

  const backgroundUrl = isAskona
    ? isMobile
      ? clientAskonaBackgroundMobile.src
      : clientAskonaBackground.src
    : isMobile
    ? getMobileBackgroundImageByRole(UserResponseDtoRoleEnum.Patient)
    : getBackgroundImageByRole(UserResponseDtoRoleEnum.Patient);

  return (
    <Root $backgroundUrl={backgroundUrl}>
      <StyledContainer>
        <Form>{activeComponent}</Form>
      </StyledContainer>
    </Root>
  );
};

const Root = styled.section<{ $backgroundUrl: string }>`
  height: calc(100vh - 58px);
  min-height: 600px;
  background-image: ${({ $backgroundUrl }) => `url(${$backgroundUrl})`};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

const StyledContainer = styled(Container)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  @media (min-width: ${BreakpointsEnum.s}px) {
    justify-content: flex-end;
  }

  @media (max-width: ${BreakpointsEnum.s}px) {
    padding-left: 0px;
    padding-right: 0px;
    justify-content: space-around;
  }
`;

const Form = styled.div`
  background-color: ${COLORS.white};
  box-shadow: 0px 12px 80px rgba(86, 118, 159, 0.08);
  border-radius: 16px;
  width: 100%;
  max-width: 440px;
`;

export default SignUp;
